/**
 * Filters out undefined and empty string values from an object
 * Useful for API params to avoid sending unnecessary query parameters
 */
export const filterEmptyParams = <T extends Record<string, unknown>>(
  params: T,
): Record<string, string> => {
  return Object.entries(params).reduce<Record<string, string>>(
    (acc, [key, value]) => {
      if (value !== undefined && value !== "") {
        acc[key] = String(value);
      }
      return acc;
    },
    {},
  );
};
